import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Image, Row, Col } from 'react-bootstrap';
import logo from '../../../assets/logo_white.svg';
import twitter from '../../../assets/icon/twitter.svg';
import x from '../../../assets/icon/x.svg';
import facebook from '../../../assets/icon/facebook.svg';
import linkedin from '../../../assets/icon/linkedin.svg';
import instagram from '../../../assets/icon/instagram.svg';
import { LanguageProvider } from '../../../core/language-provider';
import moment from 'moment';


export default function FooterBlock() {

    useEffect(() => {
        // Creo dinamicamente il tag <script> e lo inserisco nel <body> una volta sola.
        const script = document.createElement("script");
        script.src = "https://cdn.iubenda.com/iubenda.js";
        script.async = true;
        document.body.appendChild(script);

        // Pulizia opzionale: rimuovi lo script quando il componente smonta (se desiderato)
        return () => {
            document.body.removeChild(script);
        };
    }, []);



    return (
        <footer>
            <Container fluid style={{ backgroundColor: 'rgb(6, 40, 64)' }}>
                <Container fluid={'md'} className='py-5 text-white'>
                    <Row>
                        <Col md={3} xs={12} className='mb-4 text-center text-md-start'>
                            <Image src={logo} className='mb-3'></Image>
                            <p>Federazione Nazionale delle Imprese di Spedizioni Internazionali</p>
                            <div className='mt-3'>
                                <a href='https://twitter.com/fedespedi'><Image src={x} height={18} className='me-3'></Image></a>
                                <a href='https://www.linkedin.com/company/fedespedi/'><Image src={linkedin} className='me-3'></Image></a>
                                <a href='https://www.instagram.com/fedespedi/'><Image src={instagram} height={26} className='me-3'></Image></a>
                            </div>
                        </Col>
                        <Col md={3} xs={12} className='mb-4 text-center text-md-start'>
                            <h6>Contatti</h6>
                            <p className='mb-2'>{LanguageProvider.get('contatti.phone')}</p>
                            <p className='mb-2'>{LanguageProvider.get('contatti.email')}</p>
                            <p className='mb-2'>{LanguageProvider.get('contatti.address')}</p>
                            <p className='mb-2'>{LanguageProvider.get('contatti.vatNumber')}</p>
                        </Col>
                        <Col md={3} xs={12} className='mb-4 text-center text-md-start'>
                            <h6>E-Library</h6>
                            <p className='mb-2'><Link to="/">Home</Link></p>
                            <p className='mb-2'><Link to="/continua">Continua a guardare</Link></p>
                            <p className='mb-2'><Link to="/corsi">Corsi</Link></p>
                            <p className='mb-2'><Link to="/eventi">Eventi</Link></p>
                            <p className='mb-2'><Link to="/pubblicazioni">Pubblicazioni</Link></p>
                            <p className='mb-2'><Link to="/associati">Associazioni territoriali</Link></p>
                        </Col>
                        <Col md={3} xs={12} className='mb-4 text-center text-md-start'>
                            <h6>Account</h6>
                            <p className='mb-2'><Link to="/profilo">Certificati</Link></p>
                            <p className='mb-2'><a href="https://crm.fedespedi.it/reserved-area" target='_blank'>Modifica dati</a></p>
                        </Col>
                    </Row>
                </Container>
            </Container>
            <Container fluid style={{ backgroundColor: 'var(--primary-color)' }}>
                <Container fluid={'md'} className='py-2 text-white'>
                    <Row className='text-center text-md-start'>
                        <Col xs={12} md={6} className='mb-2'>
                            <p className='mb-0'>© Fedespedi 2024-{moment().year()}</p>
                        </Col>
                        <Col xs={12} md={2} className='mb-2'>
                            {/* <p className='mb-0'><a href='https://www.fedespedi.it/privacy-policy/' target='_blank'>Privacy Policy</a></p> */}
                            <p className='mb-0'>
                                <a
                                    href="https://www.fedespedi.it/privacy-policy/"
                                    title="Privacy Policy"
                                    target='_blank'
                                >
                                    Privacy Policy
                                </a>
                            </p>
                        </Col>
                        <Col xs={12} md={2} className='mb-2'>
                            {/* <p className='mb-0'><a href='https://www.fedespedi.it/cookie-policy/' target='_blank'>Cookie Policy</a></p> */}
                            <p className='mb-0'>
                                <a
                                    href="https://www.fedespedi.it/cookie-policy/"
                                    title="Cookie Policy"
                                    target='_blank'
                                >
                                    Cookie Policy
                                </a>
                            </p>
                        </Col>
                        <Col xs={12} md={2} className='mb-2'>
                            <p className='mb-0'><a
                                    href="https://www.fedespedi.it/condizioni-generali-di-servizio-della-piattaforma-elibrary-fedespedi/"
                                    title="Termini e Condizioni"
                                    target='_blank'
                                >
                                    Termini e Condizioni
                                </a></p>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </footer>
    )
};